var React = require('react');

function CloseBigInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_513","data-name":"Group 513","transform":"translate(-1192.443 -179.443)"},[React.createElement("rect",{"id":"Rectangle_239","data-name":"Rectangle 239","width":"38","height":"6","transform":"translate(1192.443 206.314) rotate(-45)","key":0}),React.createElement("rect",{"id":"Rectangle_240","data-name":"Rectangle 240","width":"38","height":"6","transform":"translate(1196.686 179.443) rotate(45)","key":1})]));
}

CloseBigInline.defaultProps = {"width":"31.113","height":"31.113","viewBox":"0 0 31.113 31.113"};

module.exports = CloseBigInline;

CloseBigInline.default = CloseBigInline;
